export const highColor = ['#a61b29', '#ed9db2']

export const midColor = ['#e4bf11', '#fed71a', '#e9ddb6']

export const lowColor = ['#15559a', '#2376b7', '#2f90b9', '#5cb3cc', '#c6e6e8']

export const interceptColor = ['#1a6840']

export const RiskLevelMap = {
  "all": "",
  "high": "high",
  "mid": "middle",
  "low": "low"
}

export const optionsRiskLevel = [
  {
    value: RiskLevelMap.all,
    label: "全部风险等级"
  },
  {
    value: RiskLevelMap.high,
    label: "高风险"
  },
  {
    value: RiskLevelMap.mid,
    label: "中风险"
  },
  {
    value: RiskLevelMap.low,
    label: "低风险"
  }
]

export const dateTypeOption = [
  {
    value: "当天",
    label: "当天"
  },
  {
    value: "最近7天",
    label: "最近7天"
  },
  {
    value: "最近三十天",
    label: "最近三十天"
  },
  {
    value: "自定义",
    label: "自定义"
  }
]

export const LineNameMap = {
  'high': '高风险',
  'middle': '中风险',
  'low': '低风险',
  'risk9-tag1': '猫池卡',
  'risk9-tag8': '疑似猫池卡',
  'risk7-tag4': '拦截卡',
  'risk6-tag2': '沉默卡',
  'risk6': '沉默卡',
  'risk5-tag6': '历史风险卡',
  'risk5': '历史风险卡',
  'risk4-tag10': '疑似真人作弊',
  'risk3-tag9': '疑似新号',
  'risk2-tag3': '账号卡',
  'risk2-tag5': '隐私小号',
  'risk2-tag7': '网络电话',
  'intercept': '拦截卡'
}